<div [formGroup]="form">
  <div formGroupName="general">
    <form-field class="front" label="Ticket Title" i18n-label="@@support.general.title.label">
      <input type="text" formControlName="title" placeholder="Enter your ticket title" i18n-placeholder="@@support.general.title.placeholder">
    </form-field>

    <form-field class="front textarea" label="Ticket Message" i18n-label="@@support.general.message.label">
      <textarea formControlName="message" placeholder="Enter your ticket message" rows="5" i18n-placeholder="@@support.general.message.placeholder"></textarea>
    </form-field>
  </div>
</div>
